import { FinanceLabField } from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { MetricCodeWithFallbacks } from "@/features/Metrics/Metrics";

export const BALANCE_SHEET_CODES: MetricCodeWithFallbacks[] = [
    [
        AccountLabel.ASSETS,
        FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
    ],
    [
        AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
        FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH,
    ],
    AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES,
    AccountLabel.CURRENT_ASSETS_NET_INVENTORY,
    AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    [
        AccountLabel.LIABILITIES,
        FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES,
    ],
    AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    AccountLabel.CURRENT_LIABILITIES_DEBT,
];

export const INCOME_STATEMENT_CODES: AccountLabel[] = [
    AccountLabel.REVENUES,
    AccountLabel.GROSS_MARGIN,
    AccountLabel.EBITDA,
    AccountLabel.EBITDA_MARGIN,
    AccountLabel.NET_INCOME,
    AccountLabel.NET_INCOME_MARGIN,
];
